import { EntityType, RoutePaths } from 'types/enums';
import { useCallback } from 'react';
import { PackType } from 'types/generated/graphql';

const packTypeToEntityType = {
    Pack: EntityType.Pack,
    Repack: EntityType.RePack,
};

const useGetEntityDetailsLink = () => {
    // Note: Should use this helper for all details link logic - https://mixgenius.atlassian.net/browse/SP-8718
    const getEntityDetailsLink = useCallback(
        (type?: EntityType | PackType, slug?: string): string | undefined => {
            let to;
            let entityType;

            if (!type || !slug) {
                return undefined;
            }

            if (type === PackType.Pack || type === PackType.Repack) {
                entityType = packTypeToEntityType[type as PackType];
            } else {
                entityType = type;
            }

            switch (entityType) {
                case EntityType.Pack:
                    to = `/${RoutePaths.Packs}/${slug}`;
                    break;

                case EntityType.RePack:
                    to = `/${RoutePaths.Collections}/${slug}`;
                    break;

                case EntityType.Label:
                    to = `/${RoutePaths.Labels}/${slug}`;
                    break;

                case EntityType.Artist:
                    to = `/${RoutePaths.Artists}/${slug}`;
                    break;
            }

            return to;
        },
        [],
    );

    return getEntityDetailsLink;
};

export default useGetEntityDetailsLink;
